import { Directive, ElementRef, Input, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appEllipsis]'
})
export class EllipsisDirective implements AfterViewInit {
  @Input() ellipsisRows: number; // 接收行数参数

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    this.applyEllipsis(element, this.ellipsisRows);
  }

  private applyEllipsis(element: HTMLElement, rows: number) {
    const lineHeight = this.getLineHeight(element);
    const originalText = element.innerText;

    if (rows) {
      const maxHeight = rows * lineHeight;
      if (element.scrollHeight > maxHeight) {
        this.renderer.setStyle(element, 'maxHeight', `${maxHeight}px`);
        this.renderer.setStyle(element, 'overflow', 'hidden');
        this.renderer.setStyle(element, 'display', '-webkit-box');
        this.renderer.setStyle(element, 'WebkitBoxOrient', 'vertical');
        this.renderer.setStyle(element, 'WebkitLineClamp', `${rows}`);
      }
    } else {
      this.renderer.setStyle(element, 'whiteSpace', 'normal');
      this.renderer.setStyle(element, 'overflow', 'hidden');

      // 使用完整的文本内容进行初始设置
      element.innerText = originalText;
      const maxHeight = element.clientHeight;

      // 延迟检查和截断，确保所有内容加载完成
      setTimeout(() => {
        if (element.scrollHeight > maxHeight) {
          this.truncateText(element, originalText, maxHeight);
        }
      }, 0);
    }
  }

  private truncateText(element: HTMLElement, text: string, maxHeight: number) {
    let truncatedText = text;
    let low = 0;
    let high = text.length;

    while (low < high) {
      const middle = Math.floor((low + high) / 2);

      truncatedText = text.slice(0, middle) + '...';
      element.innerText = truncatedText;

      if (element.scrollHeight > maxHeight) {
        high = middle - 1;
      } else {
        low = middle + 1;
      }
    }

    // 最后调整一遍确保省略号位置正确
    while (element.scrollHeight > maxHeight && truncatedText.length > 0) {
      truncatedText = truncatedText.slice(0, -4) + '...'; // 减去最后一个字符再加上省略号
      element.innerText = truncatedText;
    }
  }

  private getLineHeight(element: HTMLElement): number {
    const lineHeight = getComputedStyle(element).lineHeight;
    return lineHeight.includes('px') ?
      parseFloat(lineHeight) :
      parseFloat(lineHeight) * parseFloat(getComputedStyle(element).fontSize);
  }
}
